import { type Sale } from "@/services/marketplace/order/sales/salesTypes";
import { type UserBasicInfo } from "@/services/user";

export const createUserBasicInfoFromSale = (sale: Sale): UserBasicInfo => ({
  nickname: sale.buyer.nickname,
  avatar: sale.buyer.avatarUrl,
  rating: sale.buyer.rating,
  ratingCount: sale.buyer.ratingCount,
});

export const hasSomePackages = (sale: Sale): boolean => sale.shipping.parcels.length > 0;
